<template>
  <wsp-modal>
    <v-card class="pb-5" flat>
      <v-card-title class="pa-0">
        <v-toolbar class="primary" dark dense flat>
          <v-toolbar-title v-html="$t('parkingAccessType.electric.title')">
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="visible = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text>
        <v-list class="n-lines">
          <v-list-tile avatar class="mt-2">
            <v-list-tile-content>
              <v-list-tile-title class="mb-1">{{
                $t('parkingAccessType.electric.point1.title')
              }}</v-list-tile-title>
              <v-list-tile-sub-title>
                <span>{{ $t('parkingAccessType.electric.point1.line1') }}</span
                ><br />
                <span>{{ $t('parkingAccessType.electric.point1.line2') }}</span>
                <br />
                <span>{{ $t('parkingAccessType.electric.point1.line3') }}</span
                ><br />
                <span>{{ $t('parkingAccessType.electric.point1.line4') }}</span>
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile avatar class="mt-2" v-if="hasElectricInfo">
            <v-list-tile-content>
              <v-list-tile-title class="mb-1">{{
                $t('parkingAccessType.electric.point2.title')
              }}</v-list-tile-title>
              <v-list-tile-sub-title>
                <span v-html="electricInfo"></span>
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card-text>
    </v-card>
  </wsp-modal>
</template>

<script>
import WspModal from '@/components/commons/WspModal';
import _ from 'lodash';

export default {
  name: 'InformationElectricModal',
  components: {
    [WspModal.name]: WspModal,
  },
  props: {
    electricInfo: '',
  },
  watch: {
    visible: function (value) {
      if (!value) {
        this.$emit('on-close', {});
      }
    },
  },
  computed: {
    hasElectricInfo() {
      if (typeof this.electricInfo === 'undefined') {
        return false;
      }
      if (_.isEmpty(this.electricInfo) || this.electricInfo === '') {
        return false;
      }
      return true;
    },
  },
  data() {
    return {
      visible: true,
    };
  },
  methods: {},
};
</script>
